export enum DocumentCategory {
  STICKER = 'STICKER',
  CGV = 'CGV',
}
